import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import styles from './index.module.css';

export function SideTabsLink({
  pathname,
  label,
  isNested,
}: SideTabsLink): ReactElement {
  function creatListItemClasses(pathname: string): string {
    return classnames('tab', {
      active: window.location.pathname.includes(pathname),
    });
  }

  function createDivClasses(): string {
    return classnames('tab__heading', {
      [styles.isNested]: isNested,
    });
  }

  return (
    <li className={creatListItemClasses(pathname)} key={label}>
      <Link to={pathname}>
        <div className={createDivClasses()} title={label}>
          {label}
        </div>
      </Link>
    </li>
  );
}
